import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module typing/textwatcher
 */
import mix from '@ckeditor/ckeditor5-utils/src/mix';
import EmitterMixin from '@ckeditor/ckeditor5-utils/src/emittermixin';
import getLastTextLine from './utils/getlasttextline';
/**
 * The text watcher feature.
 *
 * Fires the {@link module:typing/textwatcher~TextWatcher#event:matched:data `matched:data`},
 * {@link module:typing/textwatcher~TextWatcher#event:matched:selection `matched:selection`} and
 * {@link module:typing/textwatcher~TextWatcher#event:unmatched `unmatched`} events on typing or selection changes.
 *
 * @private
 */

var TextWatcher =
/*#__PURE__*/
function () {
  /**
   * Creates a text watcher instance.
   * @param {module:engine/model/model~Model} model
   * @param {Function} testCallback The function used to match the text.
   */
  function TextWatcher(model, testCallback) {
    _classCallCheck(this, TextWatcher);

    this.model = model;
    this.testCallback = testCallback;
    this.hasMatch = false;

    this._startListening();
  }
  /**
   * Starts listening to the editor for typing and selection events.
   *
   * @private
   */


  _createClass(TextWatcher, [{
    key: "_startListening",
    value: function _startListening() {
      var _this = this;

      var model = this.model;
      var document = model.document;
      document.selection.on('change:range', function (evt, _ref) {
        var directChange = _ref.directChange;

        // Indirect changes (i.e. when the user types or external changes are applied) are handled in the document's change event.
        if (!directChange) {
          return;
        } // Act only on collapsed selection.


        if (!document.selection.isCollapsed) {
          if (_this.hasMatch) {
            _this.fire('unmatched');

            _this.hasMatch = false;
          }

          return;
        }

        _this._evaluateTextBeforeSelection('selection');
      });
      document.on('change:data', function (evt, batch) {
        if (batch.type == 'transparent') {
          return;
        }

        _this._evaluateTextBeforeSelection('data', {
          batch: batch
        });
      });
    }
    /**
     * Checks the editor content for matched text.
     *
     * @fires matched:data
     * @fires matched:selection
     * @fires unmatched
     *
     * @private
     * @param {'data'|'selection'} suffix A suffix used for generating the event name.
     * @param {Object} data Data object for event.
     */

  }, {
    key: "_evaluateTextBeforeSelection",
    value: function _evaluateTextBeforeSelection(suffix) {
      var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var model = this.model;
      var document = model.document;
      var selection = document.selection;
      var rangeBeforeSelection = model.createRange(model.createPositionAt(selection.focus.parent, 0), selection.focus);

      var _getLastTextLine = getLastTextLine(rangeBeforeSelection, model),
          text = _getLastTextLine.text,
          range = _getLastTextLine.range;

      var textHasMatch = this.testCallback(text);

      if (!textHasMatch && this.hasMatch) {
        /**
         * Fired whenever the text does not match anymore. Fired only when the text watcher found a match.
         *
         * @event unmatched
         */
        this.fire('unmatched');
      }

      this.hasMatch = textHasMatch;

      if (textHasMatch) {
        var eventData = Object.assign(data, {
          text: text,
          range: range
        });
        /**
         * Fired whenever the text watcher found a match for data changes.
         *
         * @event matched:data
         * @param {Object} data Event data.
         * @param {String} data.text The full text before selection.
         * @param {module:engine/model/batch~Batch} data.batch A batch associated with a change.
         */

        /**
         * Fired whenever the text watcher found a match for selection changes.
         *
         * @event matched:selection
         * @param {Object} data Event data.
         * @param {String} data.text The full text before selection.
         */

        this.fire("matched:".concat(suffix), eventData);
      }
    }
  }]);

  return TextWatcher;
}();

export { TextWatcher as default };
mix(TextWatcher, EmitterMixin);